import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  height: 100%;\n  padding-top: ', 'px;\n  padding-bottom: ', 'px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n'], ['\n  height: 100%;\n  padding-top: ', 'px;\n  padding-bottom: ', 'px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n']);

import styled from 'styled-components';

import { gridSize } from '@atlaskit/theme';

var SkeletonNavigationContentOuter = styled.div(_templateObject, gridSize() * 3, gridSize() * 2);

SkeletonNavigationContentOuter.displayName = 'SkeletonNavigationContentOuter';
export default SkeletonNavigationContentOuter;